import React, { useEffect } from 'react'
import {
    useSearchParams, Outlet,
} from 'react-router-dom-v5-compat'
import ActivateBusyMode from './ActivateBusyMode'
import useUser from '../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../NavBar/useBreadcrumb'
import { OrderStatusLabels } from './OrderLists/OrderStatusLabels'

const OrdersIndex = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const {setPaths} = useBreadcrumb()
    const [searchParams] = useSearchParams()
    const hideNavBar = JSON.parse(searchParams.get('hideNavBar'))

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('breadcrumb.orders'),
            link: false,
        }])
    }, [])

    return (
      <>
          {(!hideNavBar && user?.provider?.object?.company?.id !== '92b73161-e6ab-4581-b603-63bbe27b6c55') && (
            <ActivateBusyMode/>
          )}

          <OrderStatusLabels/>

          <Outlet />
      </>
    )
}

export default OrdersIndex
